import { z } from 'zod';
import i18n from '@/i18n';

export const registrationStepFiveSchema = z.object({
    regions: z.array(z.object({ label: z.string(), value: z.number() })).nullable(),
    // @ts-ignore
    looks_for: z.enum(['male', 'female', 'any'], { message: i18n.t('gender_required') }),
    min_age: z.number(),
    max_age: z.number(),
});

export type RegistrationStepFiveType = z.infer<typeof registrationStepFiveSchema>;
